<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,0C3.6,0,0,3.6,0,8C0,12.4,3.6,16,8,16C12.4,16,16,12.4,16,8C16,3.6,12.4,0,8,0C8,0,8,0,8,0C8,0,8,0,8,0ZM8,14C4.7,14,2,11.3,2,8C2,4.7,4.7,2,8,2C11.3,2,14,4.7,14,8C14,11.3,11.3,14,8,14C8,14,8,14,8,14C8,14,8,14,8,14Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Circle',
} as DefineComponent
</script>
